export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "es": {
        "labels": {
          "go_back_link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Volver a lista de formatos"])},
          "show_link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ver"])},
          "no_producers": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["No tiene productores asignados"])},
          "download": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Descargar"])},
          "downloading": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Descargando"])}
        }
      },
      "en": {
        "labels": {
          "go_back_link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Go back to formats list"])},
          "show_link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mostrar"])},
          "no_producers": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["No producers assigned"])},
          "download": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Download"])}
        }
      }
    }
  })
}